// SplashScreen.jsx
import React, { useContext, useState } from 'react';
import './SplashScreen.css';
import { ScreenContext } from './App';

import PlayerSelectionScreen from './PlayerSelectionScreen';


const SplashScreen = () => {

  
  const handleScreenChange = useContext(ScreenContext); 

  const PlayGame = () => {
    handleScreenChange('Home'); // Change to the 'Game' screen
  };


  return (
    
    <div className="splash-screen" >


    {/*style={{zIndex }} */}  
        
         {/* Your Logo */}
         <img
          src={require('./Assets/Images/AppDashboard/SplashScreen/gameLogo.png')}
          alt="Logo"
          className="logo-image"
        />
        {/* Play Button with Image */}
       
          <img
            src={require('./Assets/Images/AppDashboard/SplashScreen/PlayBtn.png')}
            alt="Play Button"
            className="play-icon"
            onClick={PlayGame}
          />

       
    </div>
  );
};

export default SplashScreen;